module.exports = __webpack_public_path__ + "static/media/warning.656ca8be.svg";